<script lang="ts">
	import Offcanvas from '$lib/public/layout/Offcanvas.svelte'
	import CartEditor from '$lib/public/CartEditor.svelte'

	let offcanvas: Offcanvas | undefined = $state()
</script>

<Offcanvas bind:this={offcanvas} id="cartOffcanvas" title="Review your cart.">
	<CartEditor onclose={() => offcanvas?.close()} />
</Offcanvas>
